import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, styled, Box } from '@mui/material';
import React from 'react';

import Button from 'components/Button';
import Icon from '../Icon';

import { ConfirmationModalProps } from './types';

const Modal = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: `${theme.spacing(2)}  0px`,
    borderBottom: 0
  },
  '& .MuiDialogActions-root': {
    margin: 0
  },
  '& .MuiDialogTitle-root': {
    padding: 0,
    marginBottom: theme.spacing(2)
  }
}));

const ConfirmationModal = ({
  isOpen,
  handleClose,
  handleActions,
  children,
  title,
  loading = false,
  buttonLabel = 'Submit',
  cancelLabel = 'Cancel',
  showIcon = false,
  icon = 'info-circle-linear'
}: ConfirmationModalProps) => {
  return (
    <Modal
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: theme => ({ p: theme.spacing(3), borderRadius: 3, minWidth: 300 }) }}
      open={isOpen}
      onClose={(_, reason: string) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown' && !loading) {
          handleClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {showIcon && (
        <Box
          sx={{
            background: theme => theme.palette.grey[200],
            display: 'flex',
            alignSelf: 'center',
            width: '64px',
            height: '64px',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '32px'
          }}
        >
          <Icon size={'32'} name={icon} />
        </Box>
      )}
      <DialogTitle sx={{ alignSelf: 'center', marginTop: 2 }} fontWeight={600} fontSize={16} id="alert-dialog-title">
        {title}
      </DialogTitle>
      {/*<IconButton*/}
      {/*  onClick={handleClose}*/}
      {/*  sx={{*/}
      {/*    position: 'absolute',*/}
      {/*    right: 8,*/}
      {/*    top: 15,*/}
      {/*    color: theme => theme.palette.grey[500]*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <Icon name="close-circle" />*/}
      {/*</IconButton>*/}
      <DialogContent sx={{ padding: 3, textAlign: 'center' }}>{children}</DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button variant={'outlined'} onClick={handleClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button onClick={handleActions} loading={loading || false}>
          {buttonLabel}
        </Button>
      </DialogActions>
    </Modal>
  );
};

export default ConfirmationModal;
